import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AbstractEntityDataProvider } from '@entity-framework/entity-record/entity-data-provider/abstract-entity.data-provider';
import { LoggingService } from '@logging/logging.service';
import { ForgotPasswordFormData } from './forgot-password.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ForgotPasswordDataProvider extends AbstractEntityDataProvider<ForgotPasswordFormData> {
    protected apiRoot = `${environment.apiPaths.root}User/ForgottenPassword`;

    constructor(
        protected override httpClient: HttpClient,
        protected override logger: LoggingService
    ) {
        super(httpClient, logger);
    }

    override create$(entity: ForgotPasswordFormData): Observable<ForgotPasswordFormData> {
        //TODO: this is a hacky way to get the email address to the server we need to update this to a model in the V2 API
        const params = new HttpParams().set('emailAddress', entity.emailAddress);

        return this.httpClient.post<ForgotPasswordFormData>(this.apiRoot, {}, { params: params });
    }

} 